<template>
    <div class="w-full">
        <div class="w-full text-left pl-8 py-4">All fields required</div>
        <form id="smmr-reference-form" @submit.prevent="updateReference">
            <div class="p-8 flex flex-wrap w-full  bg-gray-50" @change="dirtyForm()">
                <text-input v-model="form.known_years" class="pr-6"
                            :label="'How long have you known ' + userData.first_name + '?'"
                            :error="form.errors?.known_years"
                            @update:modelValue="value = $event"
                />
                <text-input v-model="form.known_capacity" class="pr-6"
                            :label="'In what capacity do you know '+userData.first_name+'?'"
                            :error="form.errors?.known_capacity"
                            @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8 pb-8" @change="dirtyForm()">
                <p class="text-left">How would you rate their intellectual ability?</p>
                <radio-group v-model="form.intellectual_ability_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.intellectual_ability_score"
                             :name="'intellectual_ability_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.intellectual_ability_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                :error="form.errors?.intellectual_ability_justification"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8  bg-gray-50" @change="dirtyForm()">
                <p class="text-left">How would you rate their oral communication skills?</p>
                <radio-group v-model="form.oral_communication_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.oral_communication_score"
                             :name="'oral_communication_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.oral_communication_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                :error="form.errors?.oral_communication_justification"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8" @change="dirtyForm()">
                <p class="text-left">How well does {{ userData.first_name }} work to deadlines?</p>
                <radio-group v-model="form.deadlines_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.deadlines_score"
                             :name="'deadlines_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.deadlines_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                :error="form.errors?.deadlines_justification"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8 bg-gray-50" @change="dirtyForm()">
                <p class="text-left">How well does {{ userData.first_name }} work independently?</p>
                <radio-group v-model="form.independence_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.independence_score"
                             :name="'independence_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.independence_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                :error="form.errors?.independence_justification"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8" @change="dirtyForm()">
                <p class="text-left">How well does {{ userData.first_name }} produce original work?</p>
                <radio-group v-model="form.original_work_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.original_work_score"
                             :name="'original_work_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.original_work_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                :error="form.errors?.original_work_justification"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8 bg-gray-50" @change="dirtyForm()">
                <p class="text-left">How would you rate their mathematical ability?</p>
                <radio-group v-model="form.mathematics_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.mathematics_score"
                             :name="'mathematics_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.mathematics_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                :error="form.errors?.mathematics_justification"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8" @change="dirtyForm()">
                <p class="text-left">How would you rate their English language ability?</p>
                <radio-group v-model="form.english_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.english_score"
                             :name="'english_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.english_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8 bg-gray-50" @change="dirtyForm()">
                <p class="text-left">How motivated is {{ userData.first_name }}?</p>
                <radio-group v-model="form.motivation_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.motivation_score"
                             :name="'motivation_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.motivation_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                :error="form.errors?.motivation_justification"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8" @change="dirtyForm()">
                <p class="text-left">How would you rate {{ userData.first_name }} overall?</p>
                <radio-group v-model="form.overall_ability_score"
                             :options-labels="scoreLabels"
                             :options="scoreOptions"
                             :error="form.errors?.overall_ability_score"
                             :name="'overall_ability_score'"
                             @update:modelValue="value = $event"
                />
                <textarea-input v-model="form.overall_ability_justification"
                                :label="'Please add details below'"
                                :class="'max-h-20'"
                                :error="form.errors?.overall_ability_justification"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8 bg-gray-50" @change="dirtyForm()">
                <textarea-input v-model="form.general_comments"
                                :label="'Please add any comments you feel may be relevant to this application'"
                                :class="'max-h-20'"
                                :error="form.errors?.general_comments"
                                @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8" @change="dirtyForm()">
                <p class="text-left">What is your overall recommendation?</p>
                <radio-group v-model="form.overall_recommendation"
                             :options="overallRecommendationOptions"
                             :error="form.errors?.overall_recommendation"
                             :name="'overall_recommendation'"
                             @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8 bg-gray-50" @change="dirtyForm()">
                <p class="text-left"><strong>Academic Referees Only</strong></p>
                <p class="text-left">Where would you place the applicant in their year group on academic ability?</p>
                <radio-group v-model="form.academic_placement"
                             :options="academicOptions"
                             :name="'academic_placement'"
                             :error="form.errors?.academic_placement"
                             @update:modelValue="value = $event"
                />
            </div>

            <div class="p-8" @change="dirtyForm()">
                <p class="text-left mb-4">
                    Applicants and students have a right to see any reference held on file, in line with the
                    UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
                    Please see the <a href="https://www.lshtm.ac.uk/sites/default/files/data-protection-policy.pdf">LSHTM Data Protection Policy</a> for further details.
                    If this will affect your reference, please contact <a href="mailto:admissions@lshtm.ac.uk" target="_blank">admissions@lshtm.ac.uk</a>
                </p>
                <label class="text-left">
                    <input v-model="form.communications_opt_in"
                           type="checkbox"
                           true-value="1"
                           false-value="0"
                           @update:modelValue="value = $event"
                    />
                    Please check if you do NOT want the School to pass this reference to a third party or organisation if it is required for
                    an application to a scholarship or award.
                </label>
            </div>
            <div v-if="successMessage" class="success-message m-8 w-auto">{{ successMessage }}</div>
            <div v-if="serverErrors" class="m-8 server-error">
                <p class="server-error">There were some validation issues, please check the fields above</p>
            </div>

            <div class="lg:flex justify-end w-full pb-2 -mt-4">
                <div class="relative w-auto lg:w-1/3 mx-8">
                    <application-component-save-button :disabled="true"
                                                       class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                                       type="submit"
                    >
                        Save reference progress
                        <div v-if="loading" class="lds-ring-container absolute top-10">
                            <div class="lds-ring">
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        </div>
                    </application-component-save-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TextareaInput from '../../shared/TextareaInput'
import TextInput from '../../shared/TextInput'
import RadioGroup from '@/shared/RadioGroup'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    name: 'Index.vue',
    components: {
        TextareaInput,
        TextInput,
        ApplicationComponentSaveButton,
        RadioGroup,
    },
    metaInfo: {title: 'Referee Portal'},

    props: {
        displayData: Object,
        referenceData: Object,
        userData: Object,
    },
    data() {
        return {
            personalDetailsShow: false,
            referenceDetailsShow: true,
            documentationShow: false,
            locked: false,
            form: {
                reference: this.referenceData.reference,
                application_referee_id: null,
                known_years: this.referenceData.known_years,
                known_capacity: this.referenceData.known_capacity,
                intellectual_ability_score: this.referenceData.intellectual_ability_score,
                intellectual_ability_justification: this.referenceData.intellectual_ability_justification,
                oral_communication_score: this.referenceData.oral_communication_score,
                oral_communication_justification: this.referenceData.oral_communication_justification,
                deadlines_score: this.referenceData.deadlines_score,
                deadlines_justification: this.referenceData.deadlines_justification,
                independence_score: this.referenceData.independence_score,
                independence_justification: this.referenceData.independence_justification,
                original_work_score: this.referenceData.original_work_score,
                original_work_justification: this.referenceData.original_work_justification,
                mathematics_score: this.referenceData.mathematics_score,
                mathematics_justification: this.referenceData.mathematics_justification,
                english_score: this.referenceData.english_score,
                english_justification: this.referenceData.english_justification,
                motivation_score: this.referenceData.motivation_score,
                motivation_justification: this.referenceData.motivation_justification,
                overall_ability_score: this.referenceData.overall_ability_score,
                overall_ability_justification: this.referenceData.overall_ability_justification,
                general_comments: this.referenceData.general_comments,
                document_endpoint: this.referenceData.document_endpoint,
                overall_recommendation: this.referenceData.overall_recommendation,
                academic_placement: this.referenceData.academic_placement,
                communications_opt_in: this.referenceData.communications_opt_in,
                errors: {},
            },
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            template: null,
            scoreOptions: [5, 4, 3, 2, 1, 0],
            scoreLabels: ['Excellent', 'Very Good', 'Good', 'Fair', 'Poor', 'Unable to comment'],
            scoreOptionsSmall: [1, 2, 3, 4],
            overallRecommendationOptions: ['Unable to comment', 'Do not recommend this applicant', 'Recommend this applicant', 'Strongly recommend this applicant'],
            academicOptions: ['Unable to comment', 'Below Average', 'Average', 'Above Average', 'Outstanding: top 5%'],
            documentTypes: [],
            documents: [],
            referenceDocType: null,
            applicationId: null,
            countries_of_domicile: null,

        }
    },
    computed: {
        validationErrors: {
            get: function () {
                return this.form.errors
            },
            set: function (newValue) {
                for (const key in newValue) {
                    this.form.errors[key] = newValue[key].join(' ')
                }
            },
        },

    },
    watch: {
        getDocumentTypesByPortalToken(data) {
            this.documentTypes = data
        },
    },
    created() {
    },
    methods: {
        dirtyForm() {
            this.$emit('formDirty', true)
            this.formDirty = true
            this.successMessage = ''
        },
        updateReference() {
            this.loading = true
                this.$store.dispatch('updateReferenceDetails', {
                    reference: this.$route.params.id,
                    referenceId: this.form.reference,
                    token: this.$route.params.token,
                    referenceData: this.form,
                })
                    .then((response) => {
                        this.loading = false
                        this.serverErrors = ''
                        this.successMessage = response.data
                        this.$emit('referenceSaved', true)
                        setTimeout(() => {
                            this.referenceDetailsShow = false
                            this.documentationShow = true
                            this.serverErrors = ''
                            this.successMessage = ''
                            this.form.errors = {}
                        }, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        this.serverErrors = Object.values(error.response.data.errors)
                        this.successMessage = ''
                        this.form.errors = error.response.data.errors
                        this.validationErrors = error.response.data.errors
                    })
            this.formDirty = false
            this.$emit('formDirty', false)
        },
    },
}
</script>

<style scoped>
.hide {
    display: none !important;
}
</style>


